import { useMemo } from 'react'
import { useDataValue } from 'Simple/Data.js'

export default function useDataTransform(props, data) {
  let from = useDataValue({
    context: 'comms_settings',
    path: 'from',
    viewPath: props.viewPath,
  })

  return useMemo(() => {
    if (from === null) return data
    return data.filter(d => d.id > from)
  }, [data, from])
}
